import { currency } from '../../../common/utils/currency';

const extraPrice = (price = 0) => {
    price = currency(parseFloat(price));
    return (price && `+ ${price}`) || '';
};

export { extraPrice };
